import { createAsyncThunk } from "@reduxjs/toolkit"

/**
 *
 * @TODO Fix this createAsyncThunk abstraction
 */
export const setQuery = (featureName) => {
  return createAsyncThunk(
    `${featureName}/query/setQuery`,
    async (options) => {
      return JSON.parse(JSON.stringify(options))
    }
  )
}
